import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button, Fade, Row, Col } from 'reactstrap';

class NoContent extends PureComponent {
  render() {
    const {
      heading,
      bodyText,
      buttonText,
      onClick,
    } = this.props;
    return (
      <Fade in>
        <Row>
          <Col
            className="d-flex flex-column justify-content-center align-items-center bg-gray-100 border w-100 text-center"
            style={{ height: '70vh' }}
          >
            {heading && <h4><FormattedMessage id={heading} /></h4>}
            {bodyText && <p className="text-600 body-md"><FormattedMessage id={bodyText} /></p>}
            {buttonText && onClick && <Button color="primary" onClick={onClick}><FormattedMessage id={buttonText} /></Button>}
          </Col>
        </Row>
      </Fade>
    );
  }
}

NoContent.defaultProps = {
  bodyText: '',
  heading: '',
  buttonText: '',
  onClick: '',
};

NoContent.propTypes = {
  heading: PropTypes.string,
  bodyText: PropTypes.string,
  buttonText: PropTypes.string,
  onClick: PropTypes.func,
};

export default NoContent;



// WEBPACK FOOTER //
// ./src/components/NoContent/NoContent.jsx